var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPatientDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39:381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3108 2.13445V0H5.68963V2.13445H0.779785V28H20.2206V2.135L15.3108 2.13445ZM7.33025 1.64062H13.6702V4.26945H7.33025V1.64062ZM18.58 26.3594H2.42041V3.77562H5.68963V5.91008H15.3108V3.77562H18.58V26.3594Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67987 14.1684V15.1238H8.76822V16.7645H9.67987V18.1202H11.3205V16.7645H12.2321V15.1238H11.3205V14.1684C12.8414 13.7988 13.9745 12.4261 13.9745 10.7931C13.9745 8.87744 12.4159 7.31885 10.5002 7.31885C8.58447 7.31885 7.02588 8.87744 7.02588 10.7931C7.02643 12.4261 8.15901 13.7988 9.67987 14.1684ZM10.5002 8.95947C11.5114 8.95947 12.3339 9.78197 12.3339 10.7931C12.3339 11.8043 11.5114 12.6268 10.5002 12.6268C9.48901 12.6268 8.66651 11.8043 8.66651 10.7931C8.66651 9.78197 9.48955 8.95947 10.5002 8.95947Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88232 23.0339H9.53733V24.6746H4.88232V23.0339Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4629 23.0339H16.1179V24.6746H11.4629V23.0339Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88232 19.7087H16.1184V21.3494H4.88232V19.7087Z",
    fill: "#3E3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39:381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4409,
    height: 28,
    fill: "white",
    transform: "translate(0.779785)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientDetails);
export default __webpack_public_path__ + "static/media/PatientDetails.7718d243f2deff6f1d67877a8489de2f.svg";
export { ForwardRef as ReactComponent };